// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"fd960195","698":"d652d4cb","786":"fa91fe22"}[chunkId] + ".chunk.css";
};